import { render, staticRenderFns } from "./Logotype.vue?vue&type=template&id=bf84a63c&scoped=true"
import script from "./Logotype.vue?vue&type=script&lang=ts"
export * from "./Logotype.vue?vue&type=script&lang=ts"
import style0 from "./Logotype.vue?vue&type=style&index=0&id=bf84a63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf84a63c",
  null
  
)

export default component.exports